import List from '@utils/list'
import { Operation } from '@utils/index'
import ContractDetail from '@/views/common/components/contract-detail.vue'
import { updateContractStatus } from '@api/contract/index'

const { Search, Table, Detail } = List

const search = new Search('contract.contract')
  .placeholder('searchPlaceholder')
  .add('contractType')
  .add('startDate').merge('date').label('startDate')

async function makeSure(this: any, row: any) {
  await this.$confirm(this.$t(`contract.contract.makeSureMessage`))
  await updateContractStatus({ id: row.id, status: 2 })
  this.refresh()
}

const table = new Table('contract.contract')
  .add('contractNumber').link()
  .add('contractName')
  .add('contractType')
  .add('signDate')
  .add('startDate')
  .add('endDate')
  .add('jiaOrganization')
  .add('yiOrganization')
  .add('contractDesc').width(160)
  .add('notifyNumber')

const operation = new Operation('contract.contract')
  .add('makeSure').show(item => item.status === 1).handle(makeSure)

const detail = new Detail('contract.contract')
  .setSpan(24)
  .add('detail').label('').border(false).component(ContractDetail)

export default new List()
  .url('/srmContract/getContractPage', process.env.VUE_APP_CONTRACT_API)
  .search(search)
  .table(table)
  .operation(operation)
  .detail(detail)
  .end()
